module.exports = __webpack_public_path__ + "img/xinrenquan.69fda90a.png";